import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AbstractFieldInputTypeHandlerComponent,
  FormValueReadableValue
} from "../../../../../../components/common/field/field-input/type-handler/abstract-field-input-type-handler.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {FormDefinitionFieldModel} from "../../../../../form/definition/field/api/entity/formDefinitionField.model";
import {FormValueModel} from "../../../../../form/form/value/api/entity/formValue.model";
import {MathUtils} from "../../../../../common/math.utils";
import {
  MaterializePlateExamData,
  MaterializePlateExamStaticComponent
} from "../../../api/component/materialize-plate-exam-static/materialize-plate-exam-static.component";

@Component({
  selector: 'app-materialize-plate-exam-static-field-input-handler',
  standalone: true,
  imports: [CommonModule, MaterializePlateExamStaticComponent],
  templateUrl: './materialize-plate-exam-static-field-input-handler.component.html',
  styles: [
  ]
})
export class MaterializePlateExamStaticFieldInputHandlerComponent extends AbstractFieldInputTypeHandlerComponent<FormGroup> {
  data: MaterializePlateExamData;
  initialData: MaterializePlateExamData;

    public static resolveReadableValues(value: any): Promise<FormValueReadableValue[]> {
    if (!value) {
      return Promise.resolve([]);
    }
    const parsed = JSON.parse(value as string);

    const readableValues: FormValueReadableValue[] = [];
    if (parsed.image) {
      readableValues.push(FormValueReadableValue.ofImage(parsed.image));
    }
    if (parsed.pressureLocation) {
      readableValues.push(
        FormValueReadableValue.ofText('Avant: ' + MathUtils.round(parsed.pressureLocation.top, 2) +'%'),
        FormValueReadableValue.ofText('Arrière: ' + MathUtils.round(parsed.pressureLocation.bottom, 2) +'%'),
        FormValueReadableValue.ofText('Gauche: ' + MathUtils.round(parsed.pressureLocation.topLeft + parsed.pressureLocation.bottomLeft, 2) +'%'),
        FormValueReadableValue.ofText('Droit: ' + MathUtils.round(parsed.pressureLocation.topRight + parsed.pressureLocation.bottomRight, 2) +'%'),
        FormValueReadableValue.ofText('Cadran 1: ' + MathUtils.round(parsed.pressureLocation.topLeft, 2) +'%'),
        FormValueReadableValue.ofText('Cadran 2: ' + MathUtils.round(parsed.pressureLocation.topRight, 2) +'%'),
        FormValueReadableValue.ofText('Cadran 3: ' + MathUtils.round(parsed.pressureLocation.bottomLeft, 2) +'%'),
        FormValueReadableValue.ofText('Cadran 4: ' + MathUtils.round(parsed.pressureLocation.bottomRight, 2) +'%'),
      );
    }
    return new Promise((resolve) => resolve(readableValues));
  }

  constructor(private formBuilder: FormBuilder) {
    super();
  }

  buildJsonControl(formDefinitionField: FormDefinitionFieldModel): FormGroup {
    return this.formBuilder.group({
      value: this.formBuilder.control(undefined),
    });
  }

  initiateForm(formValue: FormValueModel): void {
    this.formValue = undefined;
    this.data = undefined;
    if (formValue.value) {
      this.jsonControl.get('value').setValue(formValue.value);
      this.initialData = JSON.parse(formValue.value);
    }
    console.log('Test Maxime', formValue.value);
  }

  synchronizeValue(): string {
    return this.jsonControl.get('value').value;
  }

  onChanged(value: MaterializePlateExamData){
    this.data = value;
    if (this.data) {
      this.jsonControl.get('value').setValue(JSON.stringify({
        image: this.data.image,
        cellHeight: this.data.cellHeight,
        cellWidth: this.data.cellWidth,
        frame: {
          data: this.data.pressureData,
        },
        pressureLocation: this.data.pressureLocation,
        gravityCenters: this.data.gravityCenters,
        averageGravityCenter: this.data.averageGravityCenter,
        plate: {
          id: this.data.plate.id,
          brand: this.data.plate.brand,
          firmware: this.data.plate.firmware,
          licensed: this.data.plate.licensed,
          model: this.data.plate.model,
          serial: this.data.plate.serial,
          width: this.data.plate.width,
          height: this.data.plate.height,
          sensorWidth: this.data.plate.sensorWidth,
          sensorHeight: this.data.plate.sensorHeight,
          frameRate: this.data.plate.frameRate,
        }
      }));
    }
  }

  synchronizeRuleValue(): string {
    return this.data ? JSON.stringify({
      pressureLocation: this.data.pressureLocation,
      gravityCenters: this.data.gravityCenters,
      averageGravityCenter: this.data.averageGravityCenter,
    }) : "";
  }

}
